import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import type { GetChatAvailabilityInfo } from './types/chat-availability.types';

export const GET_CHAT_AVAILABILITY_MESSAGE_TYPE = 'get_chat_availability';

export const getChatAvailability = (): Promise<GetChatAvailabilityInfo> =>
  SocketAsFetch.fetch({
    message_type: GET_CHAT_AVAILABILITY_MESSAGE_TYPE,
    info: {
      version: 2,
    },
  });
